import React from 'react';

import RouteComponent from 'components/routes/RouteComponent';
import PrivateRoute from 'components/routes/PrivateRoute';
import RoleGatedRoute from 'components/routes/RoleGatedRoute';

const RouteFromPath = ({ ...route }) => {
  if (route.allowedRoles) {
    return <RoleGatedRoute {...route} />;
  }
  if (route.private) {
    return <PrivateRoute {...route} />;
  }
  return <RouteComponent {...route} />;
};

export default RouteFromPath;
